import { guestApi } from '@/service/guests'
import { IGuestCreateParam, IGuestUpdateParam } from '@/service/models/guest'
import { queryKeys } from '@/service/queries'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const useGuestDetail = (companyId: number, id: number, enabled = true) => {
  return useQuery({
    queryKey: queryKeys.GUEST.detail(companyId, id),
    queryFn: () => guestApi.getDetail(companyId, id),
    select: ({ data }) => data,
    enabled: enabled && !!companyId && !!id,
  })
}

export const useGuestCreate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ companyId, ...params }: IGuestCreateParam & { companyId: number }) =>
      guestApi.create(companyId, params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.GUEST.all })
    },
  })
}

export const useGuestUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      companyId,
      id,
      ...params
    }: IGuestUpdateParam & { companyId: number; id: number }) =>
      guestApi.update(companyId, id, params),
    onSuccess: (_, { companyId, id }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.GUEST.all })
      queryClient.invalidateQueries({ queryKey: queryKeys.GUEST.detail(companyId, id) })
    },
  })
}
